// src/pages/packages/steps/PackageStep1.jsx
import "./PackageStep1.scss";

import { Col, Row } from "react-bootstrap";

import AppContainer from "../../../../../commons/containers/AppContainer";
import AppInputSelectV2 from "../../../../../commons/inputs/AppInputSelectV2";
import AppInputV2 from "../../../../../commons/inputs/AppInputV2";
import AppLinkButton from "../../../../../commons/buttons/AppLinkButton";
import AppTextAreaV2 from "../../../../../commons/inputs/AppTextAreaV2";
import CalendarInputV2 from "../../../../../commons/inputs/CalendarInputV2";
import { useMemo } from "react";

function PackageStep1({ formik, next }) {
  const { values, touched, errors, handleChange, setFieldValue } = formik;

  const STATUS = useMemo(
    () => [
      { value: "ACTIVE", title: "Ativo", subtitle: "Pode vender normalmente" },
      { value: "INACTIVE", title: "Inativo", subtitle: "Não aparece para venda" },
    ],
    []
  );

  const VALIDITY = useMemo(
    () => [
      { value: "NONE", title: "Sem validade", subtitle: "Não expira" },
      { value: "DATE", title: "Data de validade", subtitle: "Você escolhe uma data final" },
    ],
    []
  );

  const showDate = values.validityType === "DATE";

  // evita bug de timezone: cria Date no horário 00:00 local
  const expiryDateAsDate =
    values.expiryDate && /^\d{4}-\d{2}-\d{2}$/.test(values.expiryDate)
      ? new Date(values.expiryDate + "T00:00:00")
      : null;

  return (
    <div className="package-step1" style={{ paddingBottom: 90 }}>
      <div className="mb-3">
        <div className="package-step1__title">Informações do pacote</div>
        <div className="package-step1__subtitle text-muted">
          Nome, descrição, status e validade.
        </div>
      </div>

      {/* Identificação */}
      <div className="package-step1__card">
        <div className="package-step1__card-title">Identificação</div>

        <Row className="g-2">
          <Col xs={12}>
            <AppInputV2
              label="Nome do pacote"
              name="name"
              isRequired
              errors={errors}
              touched={touched}
              value={values.name}
              placeholder="Ex: 10 Sessões Laser Axila"
              onChange={handleChange}
            />
          </Col>

          <Col xs={12}>
            <AppTextAreaV2
              label="Descrição (opcional)"
              name="description"
              errors={errors}
              touched={touched}
              value={values.description}
              placeholder="Ex: Pacote promocional de 10 sessões..."
              onChange={handleChange}
              formText="Aparece no checkout e no detalhe do pacote do cliente."
            />
          </Col>
        </Row>
      </div>

      {/* Regras básicas */}
      <div className="package-step1__card">
        <div className="package-step1__card-title">Regras básicas</div>

        <Row className="g-2">
          <Col xs={12} md={6} style={{zIndex: 10000}}>
            <AppInputSelectV2
              name="status"
              value={values.status}
              onChange={handleChange}
              options={STATUS}
              isSearchable={false}
            />
            {touched?.status && errors?.status ? (
              <div className="package-step1__error">{errors.status}</div>
            ) : null}
          </Col>

          <Col xs={12} md={6}>
            <AppInputSelectV2
              name="validityType"
              value={values.validityType}
              onChange={(e) => {
                const nextType = e?.target?.value;
                setFieldValue("validityType", nextType);

                if (nextType === "NONE") {
                  setFieldValue("expiryDate", "");
                }
              }}
              options={VALIDITY}
              isSearchable={false}
              formText="Define se o pacote expira ou não."
            />
            {touched?.validityType && errors?.validityType ? (
              <div className="package-step1__error">{errors.validityType}</div>
            ) : null}
          </Col>

          {showDate ? (
            <Col xs={12} md={6}>
              <CalendarInputV2
                selectionMode="single"
                name="expiryDate"
                label="Data de validade"
                isRequired
                errors={errors}
                touched={touched?.expiryDate}
                values={expiryDateAsDate}
                setDates={() => {}}
                changeDates={(iso) => setFieldValue("expiryDate", iso)}
                placeholder="Selecione a data"
              />

              {touched?.expiryDate && errors?.expiryDate ? (
                <div className="package-step1__error">{errors.expiryDate}</div>
              ) : null}
            </Col>
          ) : null}
        </Row>
      </div>

      {/* Footer sticky */}
      <div className="package-step1__footer">
        <AppContainer>
          <AppLinkButton name="Próximo" fullWidth={true} onClick={next} />
        </AppContainer>
      </div>
    </div>
  );
}

export default PackageStep1;